// src/components/Layout.jsx
import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';
import QrCode from './QrCode';
const Layout = () => {
  return (
    <>
      <Header />
      <main style={{ minHeight: 'calc(100vh - 120px)' }}>
        <Outlet />
         <QrCode />
      </main>
      <Footer />
    </>
  );
};

export default Layout;
